import PubSub from "underpub-js";

var SplashPageStyleFour = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-SplashPageStyleFour',
	};

	$.extend(true, this.options, options);

};

SplashPageStyleFour.prototype.init = function() {

	var self = this;

};

export default SplashPageStyleFour;
